import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wsim" }
const _hoisted_2 = { class: "wsim-progress-bar" }
const _hoisted_3 = { class: "wsim-progress-track" }
const _hoisted_4 = { class: "wsim-progress-label" }
const _hoisted_5 = { class: "wsim-progress-count" }
const _hoisted_6 = { class: "wsim-progress-word" }
const _hoisted_7 = {
  key: 0,
  class: "wsim-menu"
}
const _hoisted_8 = { class: "wsim-grid" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 0,
  class: "wsim-card-badge"
}
const _hoisted_11 = {
  key: 1,
  class: "wsim-card-spin"
}
const _hoisted_12 = { class: "wsim-card-text" }
const _hoisted_13 = { class: "wsim-card-name" }
const _hoisted_14 = {
  key: 0,
  class: "wsim-cart-count"
}
const _hoisted_15 = { class: "wsim-card-hint" }
const _hoisted_16 = {
  key: 1,
  class: "wsim-sub-view"
}
const _hoisted_17 = { class: "wsim-sub-title" }
const _hoisted_18 = { class: "wsim-search-wrap" }
const _hoisted_19 = { class: "wsim-products" }
const _hoisted_20 = {
  key: 1,
  class: "wsim-empty"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = { class: "wsim-prod-img" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = {
  key: 1,
  class: "wsim-prod-placeholder"
}
const _hoisted_25 = {
  key: 2,
  class: "wsim-prod-loader"
}
const _hoisted_26 = {
  key: 3,
  class: "wsim-prod-qty"
}
const _hoisted_27 = { class: "wsim-prod-info" }
const _hoisted_28 = { class: "wsim-prod-name" }
const _hoisted_29 = { class: "wsim-prod-price" }
const _hoisted_30 = {
  key: 2,
  class: "wsim-sub-view"
}
const _hoisted_31 = { class: "wsim-search-input-area" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "wsim-suggestions" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 3,
  class: "wsim-sub-view"
}
const _hoisted_36 = { class: "wsim-form" }
const _hoisted_37 = { class: "wsim-label" }
const _hoisted_38 = {
  key: 0,
  class: "wsim-yesno"
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 1,
  class: "wsim-choices"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "wsim-toast"
}

import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import api from '@/api/axiosBase';
import { getProject } from '@/api/projects';

const SIM_API = '/v2';
interface FormQuestion {
  question: string;
  type: 'text' | 'yesno' | 'choice';
  options?: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WalkthroughSimulate',
  setup(__props, { expose: __expose }) {

/* eslint-disable no-undef */
const route = useRoute();

// Unique session ID per walkthrough run so simulated actions always create a new session
const walkthroughSessionId = `wt-session-${Date.now()}-${Math.random()
  .toString(36)
  .slice(2, 8)}`;

// ── Actions config ──
const actions = [
  {
    type: 'page_view',
    emoji: '👁',
    label: 'View Product',
    hint: 'Pick a product they browsed',
    colorClass: 'wsim-c-blue',
    needsPicker: 'products' as const
  },
  {
    type: 'add_to_cart',
    emoji: '🛒',
    label: 'Add to Cart',
    hint: 'Pick a product to add',
    colorClass: 'wsim-c-amber',
    needsPicker: 'products' as const
  },
  {
    type: 'search',
    emoji: '🔍',
    label: 'Search',
    hint: 'Type a search query',
    colorClass: 'wsim-c-violet',
    needsPicker: 'search' as const
  },
  {
    type: 'purchase',
    emoji: '💳',
    label: 'Purchase',
    hint: 'Complete a purchase',
    colorClass: 'wsim-c-green',
    needsPicker: null
  },
  {
    type: 'abandon_cart',
    emoji: '🚪',
    label: 'Abandon Cart',
    hint: 'Leave without buying',
    colorClass: 'wsim-c-red',
    needsPicker: null
  },
  {
    type: 'form_submit',
    emoji: '📋',
    label: 'Submit Form',
    hint: 'Answer a few questions',
    colorClass: 'wsim-c-teal',
    needsPicker: 'form' as const
  }
];

const searchSuggestions = [
  'lavender soap',
  'soy candles',
  'gift sets',
  'charcoal bar'
];

const QUESTIONS_POOL: FormQuestion[] = [
  {
    question: 'Which scent family do you prefer?',
    type: 'choice',
    options: ['Lavender', 'Citrus', 'Woodsy', 'Unscented']
  },
  {
    question: 'Are you shopping for yourself or a gift?',
    type: 'choice',
    options: ['Myself', 'A gift', 'Both']
  },
  { question: 'Do you have sensitive skin?', type: 'yesno' },
  {
    question: 'What kind of bar soap do you usually use?',
    type: 'choice',
    options: [
      'Moisturizing',
      'Exfoliating',
      'Charcoal / detox',
      'Whatever smells good'
    ]
  },
  { question: 'Have you tried our products before?', type: 'yesno' },
  {
    question: 'How did you find us?',
    type: 'choice',
    options: [
      'Instagram',
      'TikTok',
      'Google',
      'Friend / word of mouth',
      'Farmers market'
    ]
  },
  {
    question: 'Where do you usually burn candles?',
    type: 'choice',
    options: ['Bedroom', 'Living room', 'Bathroom', 'Office']
  },
  { question: 'What scent reminds you of home?', type: 'text' },
  {
    question: 'How often do you buy soap or candles?',
    type: 'choice',
    options: [
      'Every month',
      'Every few months',
      'A couple times a year',
      'First time'
    ]
  },
  { question: 'Would you like to join our loyalty program?', type: 'yesno' },
  {
    question: 'What matters most to you in a soap?',
    type: 'choice',
    options: ['Ingredients', 'Scent', 'Lather', 'Price']
  },
  { question: 'Any ingredients you want to avoid?', type: 'text' },
  {
    question: 'Prefer soy or beeswax candles?',
    type: 'choice',
    options: ['Soy', 'Beeswax', 'No preference']
  },
  {
    question: 'Anything special we should know about your order?',
    type: 'text'
  }
];

// ── State ──
const view = ref<'menu' | 'products' | 'search' | 'form'>('menu');
const loading = ref<string | null>(null);
const doneActions = ref<string[]>([]);
const toast = ref<string | null>(null);
let toastTimer: ReturnType<typeof setTimeout> | null = null;

const productMode = ref<'page_view' | 'add_to_cart'>('page_view');
const products = ref<any[]>([]);
const productsLoading = ref(false);
const searchQuery = ref('');
const searchInput = ref('');
let productsFetched = false;

const formQuestions = ref<FormQuestion[]>([]);
const formAnswers = ref<string[]>([]);
const hasAnyAnswer = computed(() =>
  formAnswers.value.some((a) => a.trim().length > 0)
);

// Cart state
const cartItems = ref<any[]>([]);
const cartCount = computed(() => cartItems.value.length);
const hasCart = computed(() => cartItems.value.length > 0);

function cartCountFor(productId: string): number {
  return cartItems.value.filter((i: any) => i.id === productId).length;
}

const filteredProducts = computed(() => {
  const q = searchQuery.value.toLowerCase().trim();
  if (!q) return products.value;
  return products.value.filter((p: any) => p.title?.toLowerCase().includes(q));
});

// ── Lifecycle ──
onMounted(() => {
  fetchProducts();
});

// ── Methods ──
function showToast(msg: string) {
  toast.value = msg;
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toast.value = null;
  }, 2500);
}

async function fetchProducts() {
  if (productsFetched) return;
  const projectID = route.params.projectID as string;
  if (!projectID) return;
  productsLoading.value = true;
  try {
    const project = await getProject(projectID);
    const proj = project as any;
    products.value = proj?.products || [];
    productsFetched = true;
  } catch {
    // silent
  } finally {
    productsLoading.value = false;
  }
}

function handleAction(action: (typeof actions)[number]) {
  if (action.needsPicker === 'products') {
    productMode.value = action.type as 'page_view' | 'add_to_cart';
    searchQuery.value = '';
    view.value = 'products';
  } else if (action.needsPicker === 'search') {
    view.value = 'search';
  } else if (action.needsPicker === 'form') {
    // Pick 2-3 questions, ensuring a mix of types
    const count = Math.random() < 0.5 ? 2 : 3;
    const shuffled = [...QUESTIONS_POOL].sort(() => Math.random() - 0.5);
    // Try to get at least one non-text question
    const nonText = shuffled.filter((q) => q.type !== 'text');
    const textOnly = shuffled.filter((q) => q.type === 'text');
    const picked: FormQuestion[] = [];
    if (nonText.length > 0) picked.push(nonText[0]);
    if (nonText.length > 1 && count === 3) picked.push(nonText[1]);
    for (const q of textOnly) {
      if (picked.length >= count) break;
      picked.push(q);
    }
    // Fill remaining from any if needed
    for (const q of shuffled) {
      if (picked.length >= count) break;
      if (!picked.includes(q)) picked.push(q);
    }
    formQuestions.value = picked.slice(0, count);
    formAnswers.value = new Array(count).fill('');
    view.value = 'form';
  } else {
    fireAction(action.type);
  }
}

async function fireAction(
  actionType: string,
  metadata: Record<string, unknown> = {}
) {
  if (loading.value) return;
  loading.value = actionType;

  const projectID = route.params.projectID as string;
  const customerID = route.params.SimpleID as string;

  if (actionType === 'purchase') {
    const items = cartItems.value;
    metadata.amount = items.reduce(
      (sum: number, i: any) => sum + (Number(i.price) || 0),
      0
    );
    metadata.products = items.map((i: any) => ({
      id: i.id,
      title: i.title,
      price: i.price
    }));
  } else if (actionType === 'abandon_cart') {
    metadata.products = cartItems.value.map((i: any) => ({
      id: i.id,
      title: i.title
    }));
  }

  // Always include walkthrough session ID so actions group into a new session
  metadata.sessionId = walkthroughSessionId;

  try {
    await api.post(`${SIM_API}/project/${projectID}/demo/simulate-action`, {
      customerId: customerID,
      actionType,
      metadata,
      skipAI: true
    });
    if (!doneActions.value.includes(actionType)) {
      doneActions.value.push(actionType);
    }
    if (actionType === 'purchase') {
      const count = cartItems.value.length;
      cartItems.value = [];
      showToast(`💳 Purchased ${count} item${count !== 1 ? 's' : ''}!`);
    } else if (actionType === 'abandon_cart') {
      cartItems.value = [];
      showToast('🚪 Cart abandoned');
    } else {
      const msgs: Record<string, string> = {
        page_view: '👁 Product viewed',
        add_to_cart: '🛒 Added to cart',
        search: '🔍 Search tracked',
        form_submit: '📋 Form submitted'
      };
      showToast(msgs[actionType] || '✓ Done');
    }
  } catch {
    showToast('❌ Failed — try again');
  } finally {
    loading.value = null;
  }
}

async function pickProduct(prod: any) {
  if (loading.value) return;
  loading.value = prod.id;
  const actionType = productMode.value;
  const projectID = route.params.projectID as string;
  const customerID = route.params.SimpleID as string;

  const metadata: Record<string, unknown> = {
    productTitle: prod.title,
    productId: prod.id,
    sessionId: walkthroughSessionId
  };
  if (prod.variants?.[0]?.price) metadata.price = prod.variants[0].price;
  if (prod.featuredImage?.url) metadata.imageUrl = prod.featuredImage.url;

  try {
    await api.post(`${SIM_API}/project/${projectID}/demo/simulate-action`, {
      customerId: customerID,
      actionType,
      metadata,
      skipAI: true
    });
    if (!doneActions.value.includes(actionType)) {
      doneActions.value.push(actionType);
    }
    if (actionType === 'add_to_cart') {
      cartItems.value.push({
        id: prod.id,
        title: prod.title,
        price: prod.variants?.[0]?.price || '0.00',
        imageUrl: prod.featuredImage?.url
      });
      showToast(`🛒 Added ${prod.title} (${cartCount.value} in cart)`);
      view.value = 'menu';
    } else {
      showToast(`👁 Viewed ${prod.title}`);
      view.value = 'menu';
    }
  } catch {
    showToast('❌ Failed — try again');
  } finally {
    loading.value = null;
  }
}

async function submitSearch() {
  const q = searchInput.value.trim();
  if (!q || loading.value) return;
  loading.value = 'search';
  const projectID = route.params.projectID as string;
  const customerID = route.params.SimpleID as string;

  try {
    await api.post(`${SIM_API}/project/${projectID}/demo/simulate-action`, {
      customerId: customerID,
      actionType: 'search',
      metadata: { searchQuery: q, sessionId: walkthroughSessionId },
      skipAI: true
    });
    if (!doneActions.value.includes('search')) {
      doneActions.value.push('search');
    }
    showToast(`🔍 Searched "${q}"`);
    searchInput.value = '';
    view.value = 'menu';
  } catch {
    showToast('❌ Failed — try again');
  } finally {
    loading.value = null;
  }
}

async function submitForm() {
  if (loading.value || !hasAnyAnswer.value) return;
  loading.value = 'form_submit';
  const projectID = route.params.projectID as string;
  const customerID = route.params.SimpleID as string;

  const questions: string[] = [];
  const answers: string[] = [];
  formQuestions.value.forEach((q, i) => {
    questions.push(q.question);
    answers.push(formAnswers.value[i]?.trim() || '');
  });

  try {
    await api.post(`${SIM_API}/project/${projectID}/demo/simulate-action`, {
      customerId: customerID,
      actionType: 'form_submit',
      metadata: { questions, answers, sessionId: walkthroughSessionId },
      skipAI: true
    });
    if (!doneActions.value.includes('form_submit')) {
      doneActions.value.push('form_submit');
    }
    showToast('📋 Form submitted!');
    view.value = 'menu';
  } catch {
    showToast('❌ Failed — try again');
  } finally {
    loading.value = null;
  }
}

function formatPrice(prod: any) {
  const v = prod.variants?.[0];
  if (v?.price) return `$${Number(v.price).toFixed(2)}`;
  if (prod.price) return `$${Number(prod.price).toFixed(2)}`;
  return '';
}

// Allow parent to read state and reset
__expose({
  doneActions,
  doneCount: computed(() => doneActions.value.length),
  view,
  searchInput,
  submitSearch,
  submitForm,
  hasAnyAnswer,
  reset() {
    loading.value = null;
    doneActions.value = [];
    cartItems.value = [];
    toast.value = null;
    view.value = 'menu';
    searchQuery.value = '';
    searchInput.value = '';
    if (toastTimer) clearTimeout(toastTimer);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "wsim-progress-fill",
          style: _normalizeStyle({ width: `${(doneActions.value.length / 3) * 100}%` })
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(doneActions.value.length), 1),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "wsim-progress-sep" }, "/", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "wsim-progress-total" }, "3", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(doneActions.value.length >= 3 ? '— Nice work! 🎉' : 'actions to try'), 1)
      ])
    ]),
    (view.value === 'menu')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "wsim-heading" }, [
            _createElementVNode("h2", { class: "wsim-title" }, "Simulate a Customer Action"),
            _createElementVNode("p", { class: "wsim-sub" }, " Tap an action below to trigger the AI — watch it respond in real-time. ")
          ], -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(actions, (action) => {
              return _createElementVNode("button", {
                key: action.type,
                class: _normalizeClass(["wsim-card", {
            'wsim-card-done': doneActions.value.includes(action.type),
            'wsim-card-busy': loading.value === action.type,
            'wsim-card-disabled':
              (action.type === 'purchase' || action.type === 'abandon_cart') &&
              !hasCart.value
          }]),
                disabled: 
            !!loading.value ||
            ((action.type === 'purchase' || action.type === 'abandon_cart') &&
              !hasCart.value)
          ,
                onClick: ($event: any) => (handleAction(action))
              }, [
                (doneActions.value.includes(action.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          d: "M2.5 7L5.5 10L11.5 4",
                          stroke: "white",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (loading.value === action.type)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["wsim-card-emoji", action.colorClass])
                }, _toDisplayString(action.emoji), 3),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createTextVNode(_toDisplayString(action.label) + " ", 1),
                    (action.type === 'add_to_cart' && cartCount.value > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(cartCount.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, _toDisplayString((action.type === 'purchase' ||
                  action.type === 'abandon_cart') &&
                !hasCart.value
                  ? 'Add something to cart first'
                  : action.hint), 1)
                ])
              ], 10, _hoisted_9)
            }), 64))
          ])
        ]))
      : (view.value === 'products')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("h3", _hoisted_17, _toDisplayString(productMode.value === 'add_to_cart'
            ? 'Pick a product to add'
            : 'Pick a product to view'), 1),
            _createElementVNode("div", _hoisted_18, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                class: "wsim-search-icon",
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none"
              }, [
                _createElementVNode("circle", {
                  cx: "7",
                  cy: "7",
                  r: "5.5",
                  stroke: "#9ca3af",
                  "stroke-width": "1.5"
                }),
                _createElementVNode("path", {
                  d: "M11 11L14 14",
                  stroke: "#9ca3af",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                class: "wsim-search",
                placeholder: "Search products...",
                type: "text"
              }, null, 512), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (productsLoading.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(6, (i) => {
                    return _createElementVNode("div", {
                      key: 'skel-' + i,
                      class: "wsim-prod wsim-skel"
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "wsim-skel-img" }, null, -1),
                      _createElementVNode("div", { class: "wsim-skel-line wsim-skel-name" }, null, -1),
                      _createElementVNode("div", { class: "wsim-skel-line wsim-skel-price" }, null, -1)
                    ]))])
                  }), 64))
                : (filteredProducts.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No products found "))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (prod) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: prod.id,
                  class: _normalizeClass(["wsim-prod", { 'wsim-prod-busy': loading.value === prod.id }]),
                  disabled: !!loading.value,
                  onClick: ($event: any) => (pickProduct(prod))
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (prod.featuredImage?.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: prod.featuredImage.url,
                          alt: prod.title
                        }, null, 8, _hoisted_23))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, "📦")),
                    (loading.value === prod.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                      : _createCommentVNode("", true),
                    (productMode.value === 'add_to_cart' && cartCountFor(prod.id) > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(cartCountFor(prod.id)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(prod.title), 1),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(formatPrice(prod)), 1)
                  ])
                ], 10, _hoisted_21))
              }), 128))
            ])
          ]))
        : (view.value === 'search')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "wsim-sub-title" }, "What did the customer search?", -1)),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
                  class: "wsim-big-input",
                  placeholder: "e.g. lavender soap, soy candles...",
                  type: "text",
                  onKeyup: _withKeys(submitSearch, ["enter"])
                }, null, 544), [
                  [_vModelText, searchInput.value]
                ]),
                _createElementVNode("button", {
                  class: "wsim-submit-btn",
                  disabled: !!loading.value || !searchInput.value.trim(),
                  onClick: submitSearch
                }, _toDisplayString(loading.value === 'search' ? 'Searching...' : 'Search →'), 9, _hoisted_32)
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(searchSuggestions, (s) => {
                  return _createElementVNode("span", {
                    key: s,
                    class: "wsim-suggestion",
                    onClick: ($event: any) => (searchInput.value = s)
                  }, _toDisplayString(s), 9, _hoisted_34)
                }), 64))
              ])
            ]))
          : (view.value === 'form')
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "wsim-sub-title" }, "Customer Survey", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formQuestions.value, (q, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "wsim-field"
                    }, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(q.question), 1),
                      (q.type === 'yesno')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["wsim-yn-btn", { active: formAnswers.value[idx] === 'Yes' }]),
                              onClick: ($event: any) => (formAnswers.value[idx] = 'Yes')
                            }, " Yes ", 10, _hoisted_39),
                            _createElementVNode("button", {
                              class: _normalizeClass(["wsim-yn-btn", { active: formAnswers.value[idx] === 'No' }]),
                              onClick: ($event: any) => (formAnswers.value[idx] = 'No')
                            }, " No ", 10, _hoisted_40)
                          ]))
                        : (q.type === 'choice')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.options, (opt) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: opt,
                                  class: _normalizeClass(["wsim-choice-pill", { active: formAnswers.value[idx] === opt }]),
                                  onClick: ($event: any) => (formAnswers.value[idx] = opt)
                                }, _toDisplayString(opt), 11, _hoisted_42))
                              }), 128))
                            ]))
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 2,
                              "onUpdate:modelValue": ($event: any) => ((formAnswers.value[idx]) = $event),
                              class: "wsim-input",
                              type: "text",
                              placeholder: "Type anything..."
                            }, null, 8, _hoisted_43)), [
                              [_vModelText, formAnswers.value[idx]]
                            ])
                    ]))
                  }), 128)),
                  _createElementVNode("button", {
                    class: "wsim-submit-btn",
                    disabled: !!loading.value || !hasAnyAnswer.value,
                    onClick: submitForm
                  }, _toDisplayString(loading.value === 'form_submit' ? 'Submitting...' : 'Submit Form →'), 9, _hoisted_44)
                ])
              ]))
            : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "wsim-toast-anim" }, {
      default: _withCtx(() => [
        (toast.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(toast.value), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})